export enum CorrugatedCartonBoxesLabels {
  dimensions = "dimensions",
  type = "type",
  material = "material",
  print = "print",
}
